export class DeviceInfo{
    MachineKey:string
      constructor(values: Object = {}){ 
        Object.assign(this, values);   
    }
}